import { useDrawerStore } from '@/stores/drawerStore';
import type { SiteData } from '@/types/site';
import { useEffect } from 'react';

/**
 * 새로고침 후 drawer 상태 복원을 위한 커스텀 훅
 * 사이트 데이터가 로드되면 저장된 selectedSiteId로 사이트 데이터를 복원합니다.
 */
export function useDrawerRestore(sites: SiteData[]) {
  const { selectedSiteId, activeDrawer, restoreSiteData } = useDrawerStore();

  useEffect(() => {
    // 저장된 사이트 ID가 있고, active drawer가 있으며, 사이트 데이터가 로드되었을 때
    if (selectedSiteId && activeDrawer && sites.length > 0) {
      // 저장된 siteId로 사이트 데이터 찾기
      const foundSite = sites.find((site) => site.siteId === selectedSiteId);

      if (foundSite) {
        // 찾은 사이트 데이터로 선택된 사이트 복원
        restoreSiteData(foundSite);
      } else {
        // 해당 사이트가 더 이상 존재하지 않으면 drawer 상태 초기화
        console.warn(
          `저장된 사이트 ID ${selectedSiteId}를 찾을 수 없습니다. Drawer 상태를 초기화합니다.`
        );
        useDrawerStore.getState().closeDrawer();
      }
    }
  }, [selectedSiteId, activeDrawer, sites, restoreSiteData]);
}

/**
 * 사이트 선택 시 URL 파라미터 동기화를 위한 유틸리티 함수
 * 선택적으로 사용할 수 있습니다.
 */
export function useSiteUrlSync() {
  const { selectedSiteId, activeDrawer } = useDrawerStore();

  useEffect(() => {
    const url = new URL(window.location.href);

    if (selectedSiteId && activeDrawer) {
      url.searchParams.set('siteId', selectedSiteId);
      url.searchParams.set('drawer', activeDrawer);
    } else {
      url.searchParams.delete('siteId');
      url.searchParams.delete('drawer');
    }

    // URL 업데이트 (히스토리에 추가하지 않음)
    window.history.replaceState({}, '', url.toString());
  }, [selectedSiteId, activeDrawer]);
}
